import { coachApi } from '@shared/api/client';
import type { AnalyticsRecord } from './types';
import { adaptAnalyticsRecord } from './adapters';

export const analyticsApi = {
  getAnalytics: async (siteId: string): Promise<AnalyticsRecord> => {
    const raw = await coachApi.get<unknown>(`/webbuilder/sites/${siteId}/analytics`);
    return adaptAnalyticsRecord(raw);
  },
};

export const webbuilderApi = analyticsApi;
export type * from './types';
